import React, { FC, ReactNode } from 'react';
import { Text } from 'snacks-design-system';
import styles from './PIEText.module.scss';
import DOMPurify from 'dompurify';

/* https://snacks.takeaway.com/portal/components/text/usage/ */

interface IPIEText {
  text: string | ReactNode;
  size: string;
  fontWeight?: string;
  color?: string;
  lineHeight?: string;
  align?: 'left' | 'right' | 'center';
  allowCaps?: boolean | null;
  truncate?: boolean;
  disabled?: boolean;
  underline?: boolean;
  elipsis?: boolean;
  maxWidth?: string;
  modCaps?: boolean;
  customStyle?: React.CSSProperties;
}

export const PIEText: FC<IPIEText> = ({
  text,
  size,
  fontWeight,
  color,
  lineHeight,
  align,
  allowCaps,
  truncate,
  underline,
  disabled,
  elipsis,
  maxWidth,
  customStyle = {},
}) => {
  return (
    <div
      className={`${styles.container} ${elipsis ? styles.container_elipsis : ''}`}
      style={{ ...customStyle, width: 'auto', maxWidth: maxWidth }}
    >
      <Text
        size={size}
        fontWeight={fontWeight}
        color={color}
        lineHeight={lineHeight}
        align={align}
        modCaps={allowCaps}
        modTruncate={truncate}
        modUnderline={underline}
        modRoleText={disabled}
      >
        {(typeof text === 'string' && (
          <div
            style={{ whiteSpace: 'normal' }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(text, {}),
            }}
          ></div>
        )) ||
          text}
      </Text>
    </div>
  );
};

export default PIEText;
